/* ==========================================================================
   ZELICAT THEME — cart-recommendations.js
   Loads Shopify's product recommendations for the first item in the cart (Section Rendering API) into the
   "You may also like" section, and refreshes them when the cart changes. Hides the block when there are none.
   ========================================================================== */
(() => {
  'use strict';
  const ZC = window.ZC;
  if (!ZC) return;
  const { $$ } = ZC;

  ZC.mount((root) => {
    $$('[data-cart-recs]', root).forEach((el) => {
      if (!ZC.once(el, 'recs')) return;
      let currentId = el.dataset.productId || '';
      let request = 0;

      const load = async (id) => {
        const ticket = ++request;
        try {
          const res = await fetch(`${el.dataset.url}&product_id=${encodeURIComponent(id)}`);
          if (!res.ok) throw new Error(String(res.status));
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          if (ticket !== request) return;                      // a newer request is running
          const fresh = doc.querySelector('[data-cart-recs]');
          el.innerHTML = fresh ? fresh.innerHTML : '';
          requestAnimationFrame(() => $$('.reveal', el).forEach((i) => i.classList.add('is-in')));
        } catch (err) {
          if (ticket === request) el.innerHTML = '';
        }
      };

      if (el.dataset.enabled === 'true' && currentId && !el.querySelector('section')) load(currentId);

      const onCart = (e) => {
        if (!el.isConnected) { document.removeEventListener('zc:cart:updated', onCart); return; }
        if (el.dataset.enabled !== 'true') return;
        const items = (e.detail && e.detail.cart && e.detail.cart.items) || [];
        const id = items.length ? String(items[0].product_id) : '';
        if (id === currentId) return;
        currentId = id;
        if (!id) { request++; el.innerHTML = ''; return; }
        load(id);
      };
      document.addEventListener('zc:cart:updated', onCart);
    });
  });
})();
